import { Name } from './../../../../../models/ShuttleReservationsViewmodel';
import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { MyConfigOrganization } from '../../../../../../app/models/myConfig';
import { EditOrganizationAdditionalServiceRequest, OrganizationAdditionalServiceVM } from '../../../../../../app/models/orderModel';
import { BackOfficeService } from '../../../../../services/backoffice.service';

@Component({
  selector: 'app-additional-services-form',
  templateUrl: './additional-services-form.component.html',
  styleUrl: './additional-services-form.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdditionalServicesFormComponent {
  @Output() saveChangesEvent = new EventEmitter<void>();
  isLoading: boolean = false;
  additionalServiceForm: UntypedFormGroup;
  componentDestroyed$: Subject<boolean> = new Subject();
  activeRequests: number = 0;
  statusOptions: any[] = [
    { value: 1, name: 'Active' },
    { value: 0, name: 'Disabled' },
    { value: 2, name: 'FewLeft' }
  ];
  availableSubServiceOrgs: any[] = [];

  constructor(
    private fb: UntypedFormBuilder,
    private BackOfficeService: BackOfficeService,
    // private parkingService: ParkingService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { additionalService: any, organization: MyConfigOrganization, edit: boolean },
    @Inject(MatDialogRef<AdditionalServicesFormComponent>) private dialogRef: MatDialogRef<AdditionalServicesFormComponent>
  ) {
    this.initEmptyAdditionalServiceForm();
  }

  ngOnInit(): void {
    this.getSubOrgs();
    console.log("additionalservice", this.data.additionalService);
    this.data.additionalService ? this.initAdditionalServiceForm() : this.initEmptyAdditionalServiceForm();
  }

  setSwedishTimeZone(controlName: string, event: any) {
    const selectedDate = new Date(event.value);
    if (selectedDate) {
      const swedishOffset = -new Date().getTimezoneOffset();
      const swedishDate = new Date(selectedDate.getTime() + swedishOffset * 60 * 1000);
      this.additionalServiceForm.get(controlName)?.setValue(swedishDate.toISOString().replace('Z', ''));
    } else {
      this.additionalServiceForm.get(controlName)?.setValue(null);
    }
  }

  private setLoadingState(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  private incrementRequests() {
    this.activeRequests++;
    this.setLoadingState(true);
  }

  private decrementRequests() {
    if (this.activeRequests > 0)
      this.activeRequests--;
    if (this.activeRequests === 0) {
      this.setLoadingState(false);
    }
  }

  submitForm() {
    this.incrementRequests();
    var model: EditOrganizationAdditionalServiceRequest = this.createAdditionalServicePayload();
    console.log(model);

    this.BackOfficeService
      .saveOrganizationAdditionalServices(this.data.organization.organizationId, model)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe({
        next: (additionalService) => {
          // this.snackBar.open('Discount check created: ' + discountCheck.id, 'Success', {
          //   verticalPosition: 'top',
          //   duration: 2000
          // });
          this.decrementRequests();
          console.log('additionalService : ', additionalService);
          this.saveChangesEvent.emit(additionalService);
          this.dialogRef.close();
        },
        error: (err) => {
          this.snackBar.open('Failed to create / edit Additional Service: ' + err.message, 'Error', {
            verticalPosition: 'top',
            duration: 2000
          });
          this.decrementRequests();
        }
      });
  }

  createAdditionalServicePayload(): EditOrganizationAdditionalServiceRequest {
    return {
      id: this.additionalServiceForm.controls['id'].value !== '' ? this.additionalServiceForm.controls['id'].value : null,
      name: {
        en: this.additionalServiceForm.controls['nameEn'].value || '',
        sv: this.additionalServiceForm.controls['nameSv'].value || ''
      },
      description: {
        en: this.additionalServiceForm.controls['descriptionEn'].value || '',
        sv: this.additionalServiceForm.controls['descriptionSv'].value || ''
      },
      productId: this.additionalServiceForm.controls['productId'].value !== '' ? this.additionalServiceForm.controls['productId'].value : null,
      productCode: this.additionalServiceForm.controls['productCode'].value || '',
      availability: this.additionalServiceForm.controls['availability'].value || 0,
      minimumStay: this.additionalServiceForm.controls['minimumStay'].value || 0,
      // statusName: this.additionalServiceForm.controls['statusName'].value || '',
      status: this.additionalServiceForm.controls['statusName'].value,
      // typeName: this.additionalServiceForm.controls['typeName'].value || '',
      isMandatory: this.additionalServiceForm.controls['mandatory'].value,
      price: this.additionalServiceForm.controls.totalPrice.value/(1 + (this.additionalServiceForm.controls.vatPercentage.value/100)) || 0,
      // vat: this.additionalServiceForm.controls['vat'].value || 0,
      // vatPercentage: this.additionalServiceForm.controls['vatPercentage'].value || 25,
      // totalPrice: this.additionalServiceForm.controls['totalPrice'].value || 0,
      // discountAmount: this.additionalServiceForm.controls['discountAmount'].value || 0,
      // discountVatAmount: this.additionalServiceForm.controls['discountVatAmount'].value || 0,
      // discountTotalPrice: this.additionalServiceForm.controls['discountTotalPrice'].value || 0,
      // discountCheckPercent: this.additionalServiceForm.controls['discountCheckPercent'].value || 0,
      // discountCheckAmount: this.additionalServiceForm.controls['discountCheckAmount'].value || 0,
      // performingOrganizationName: this.additionalServiceForm.controls['performingOrganizationName'].value || ''
      performingOrganizationId: this.additionalServiceForm.controls['performingOrganization'].value.id || this.data.organization.organizationId
    };
  }

  initAdditionalServiceForm() {
    this.additionalServiceForm = this.fb.group({
      id: [{ value: this.data.additionalService.id || '', disabled: this.isLoading || this.data.edit }],
      nameEn: [{ value: this.parseStringifiedObject(this.data.additionalService.name).en || '', disabled: this.isLoading }, Validators.required],
      nameSv: [{ value: this.parseStringifiedObject(this.data.additionalService.name).sv || '', disabled: this.isLoading }, Validators.required],
      descriptionEn: [{ value: this.parseStringifiedObject(this.data.additionalService.description).en || '', disabled: this.isLoading }],
      descriptionSv: [{ value: this.parseStringifiedObject(this.data.additionalService.description).sv || '', disabled: this.isLoading }],
      productId: [{ value: this.data.additionalService.productId || '', disabled: this.isLoading || this.data.edit }],
      productCode: [{ value: this.data.additionalService.productCode || '', disabled: this.isLoading }, Validators.required],
      availability: [{ value: this.data.additionalService.availability || 0, disabled: this.isLoading }, Validators.required],
      minimumStay: [{ value: this.data.additionalService.minimumStay || '', disabled: this.isLoading }],
      statusName: [{
        value: this.statusOptions.find(option => option.name === this.data.additionalService.statusName)?.value ,
        disabled: this.isLoading
      }, Validators.required],
      mandatory: [{ value: this.data.additionalService.typeName === "MandatoryForAllAdditionalServices" || false, disabled: this.isLoading }],
      typeName: [{ value: this.data.additionalService.typeName || '', disabled: this.isLoading }],
      price: [{ value: 0, disabled: true }, [Validators.required, Validators.min(1)]],
      vat: [{ value: 0, disabled: true }],
      vatPercentage: [{ value: this.data.additionalService.vatPercentage || 25, disabled: true }],
      totalPrice: [{ value: 0, disabled: this.isLoading }, [Validators.required, Validators.min(1)]],
      discountAmount: [{ value: this.data.additionalService.discountAmount || '', disabled: this.isLoading }],
      discountVatAmount: [{ value: this.data.additionalService.discountVatAmount || '', disabled: this.isLoading }],
      discountTotalPrice: [{ value: this.data.additionalService.discountTotalPrice || '', disabled: this.isLoading }],
      discountCheckPercent: [{ value: this.data.additionalService.discountCheckPercent || '', disabled: this.isLoading }],
      discountCheckAmount: [{ value: this.data.additionalService.discountCheckAmount || '', disabled: this.isLoading }],
      performingOrganizationName: [{ value: this.data.additionalService.performingOrganizationName || '', disabled: true }],
      performingOrganization: [{ value:
        this.availableSubServiceOrgs.find(org => org.label === this.data.additionalService.performingOrganizationName || ''),
        disabled: this.isLoading
      }],
    });

    this.additionalServiceForm.controls.price.setValue(this.data.additionalService.price, { emitEvent: false });
    this.additionalServiceForm.controls.vat.setValue(this.data.additionalService.price * ( this.data.additionalService.vatPercentage/100 ), { emitEvent: false });
    this.additionalServiceForm.controls.totalPrice.setValue(this.data.additionalService.price * (1 + (this.data.additionalService.vatPercentage/100)), { emitEvent: false });
  }

  getSubOrgs() {
    this.availableSubServiceOrgs.push({
      id: this.data.organization.organizationId,
      label: this.data.organization.organizationName,
    })

    this.data.organization.config.subOrganizations.forEach(org => {
      if( org.typeName === "ServicePerformer"){
        this.availableSubServiceOrgs.push({
          id: org.organizationId,
          label: org.name
        });
      }
    });
  }

  initEmptyAdditionalServiceForm() {
    this.additionalServiceForm = this.fb.group({
      id: [{ value: '', disabled: this.isLoading || this.data.edit }],
      nameEn: [{ value: '', disabled: this.isLoading }, Validators.required],
      nameSv: [{ value: '', disabled: this.isLoading }, Validators.required],
      descriptionEn: [{ value: '', disabled: this.isLoading }],
      descriptionSv: [{ value: '', disabled: this.isLoading }],
      productId: [{ value: '', disabled: this.isLoading || this.data.edit }],
      productCode: [{ value: '', disabled: this.isLoading }, Validators.required],
      availability: [{ value: 0, disabled: this.isLoading }, Validators.required],
      minimumStay: [{ value: '', disabled: this.isLoading }, Validators.required],
      statusName: [{ value: 1, disabled: this.isLoading }, Validators.required],
      mandatory: [{ value: false, disabled: true }],
      typeName: [{ value: '', disabled: this.isLoading }],
      price: [{ value: 0, disabled: true }, [Validators.required, Validators.min(0.01)]],
      vat: [{ value: 0, disabled: true }],
      vatPercentage: [{ value: 25, disabled: true }],
      totalPrice: [{ value: 0, disabled: this.isLoading }],
      discountAmount: [{ value: '', disabled: this.isLoading }],
      discountVatAmount: [{ value: '', disabled: this.isLoading }],
      discountTotalPrice: [{ value: '', disabled: this.isLoading }],
      discountCheckPercent: [{ value: '', disabled: this.isLoading }],
      discountCheckAmount: [{ value: '', disabled: this.isLoading }],
      performingOrganizationName: [{ value: '', disabled: true }],
      performingOrganization: [{ value: '', disabled: this.isLoading }],
    });
  }

  clearDate(event, value) {
    event.stopPropagation();
    value.setValue('', { emitEvent: false });
  }


  parseStringifiedObject<T = any>(stringifiedObject: string): T | null {
    try {
      return JSON.parse(stringifiedObject) as T;
    } catch (error) {
      console.error('Failed to parse stringified object:', error);
      return null;
    }
  }
}
